import React, { memo } from 'react';
import { getTableRowModeBoolean } from 'shared/Table/Actions/utilities';
import { useTableActiveRowContext } from 'shared/Table/TableActiveRowContext';
import { IRenewalSowDataItem } from '@EngagementsRenewalSowData/renewalSowData.models';
import CancelOrderModalForm from 'pages/WirelineEngagements/shared/CancelOrderModalForm';
import { cancelOrderTitle } from 'pages/WirelineEngagements/shared/CancelOrderModalForm/constants';

const CancelOrderModal = () => {
  const {
    activeRow,
    activeRowMode,
    cleanActiveRow,
  } = useTableActiveRowContext<IRenewalSowDataItem>();

  const { isCancelOrderMode } = getTableRowModeBoolean(activeRowMode);

  return (
    <CancelOrderModalForm
      activeRow={activeRow}
      title={cancelOrderTitle}
      isOpen={isCancelOrderMode}
      cleanActiveRow={cleanActiveRow}
    />
  );
};

export default memo(CancelOrderModal);
